var ICON_URL = 'https://icons.multifarm.fi';
export function getAssetIcon(assetName) {
    return getRemoteIcon('asset', assetName);
}
export function getRemoteIcon(type, icon) {
    return "".concat(ICON_URL, "/").concat(type, "/").concat(icon);
}
